const zIndexOfMarker: {
    [key: string]: number;
} = {
    top: 11,
    mid: 9,
    bot: 7,
    low: 5,
    item: 5,
    multi: 5,
    real: 3,
    expGroup: 4,
};

export default zIndexOfMarker;
